import axios from '../utils/axiosClient';
import endpoints from './endpoints';

const {
  getSubUsers,
  destroySubUser,
  createSubUser,
  createMainSubUser,
  editSubUser,
  resetSubUserPassword,
  changeSubUserState,
  getSubUserCredentialsPdf,
} = endpoints;

const loadSubUsers = async (params: any) => {
  try {
    const response = await axios.get(getSubUsers, { params });
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response);
  }
};

const deleteSubUser = async (id: string) => {
  try {
    const response = await axios.delete(destroySubUser(id));
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response);
  }
};

const resetPassword = async (id: string) => {
  try {
    const response = await axios.post(resetSubUserPassword(id));
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response);
  }
};

const create = async (data: any) => {
  try {
    const response = await axios.post(createSubUser, data);
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response);
  }
};

const createMain = async (data: any) => {
  try {
    const response = await axios.post(createMainSubUser, data);
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response);
  }
};

const edit = async (id: string, data: any) => {
  try {
    const response = await axios.put(editSubUser(id), data);
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response);
  }
};

const changeState = async (id: string, enabled: boolean) => {
  try {
    const response = await axios.post(changeSubUserState(id), { enabled });
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response);
  }
};

const getCredentialsPdf = async (params: any) => {
  try {
    const response = await axios.get(getSubUserCredentialsPdf, { params });
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response);
  }
};

const subUserServices = { loadSubUsers, deleteSubUser, create, createMain, edit, resetPassword, changeState, getCredentialsPdf };

export default subUserServices;
